import { render, staticRenderFns } from "./OrderWorklogsCreateFab.vue?vue&type=template&id=6880ea86&"
import script from "./OrderWorklogsCreateFab.vue?vue&type=script&lang=ts&"
export * from "./OrderWorklogsCreateFab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports